export const imagePath = {
  appLogo: require('../assets/images/app_logo.png'),
  background: require('../assets/images/background.png'),
  direction: require('../assets/images/direction.png'),
  lowPrice: require('../assets/images/zsticker.webp'),
  fastSupport: require('../assets/images/zsupport.webp'),
  quality: require('../assets/images/zdiamond.webp'),
  return: require('../assets/images/return-1.webp'),
  copyLink: require('../assets/images/copy-link.webp'),
  facebook: require('../assets/images/facebook.webp'),
  instagram: require('../assets/images/instagram.png'),
  whatsapp: require('../assets/images/whatsapp.webp'),
  gmail: require('../assets/images/gmail.webp'),
  moreApp: require('../assets/images/more-app.webp'),
};